import { renderContextMenuAtPosition } from '@shared/ui-react/ContextMenu';
import { mapTools, mapWrapper, mapRootStore } from '@pages/map/map';
import { AreaTool } from '@openlayers/tools/tool-area';
import { XmlExport } from '@pages/map/tools/XmlExport';
import { Drawer } from '@shared/ui-native/Drawer';
import { MaterialsStore } from '@pages/trucks/store/MaterialsStore';
import { GeofenceEditor } from '@pages/trucks/geofences/GeofenceEditor';
import { GeofencesStore } from '@pages/trucks/store/GeofencesStore';
import Feature from 'ol/Feature';
import { Pixel } from 'ol/pixel';
import { KmlExport } from '@openlayers/tools/KmlExport';
import { MeasurementEditor } from '@openlayers/map-measurements/MeasurementEditComponent';
import { getSingleMeasurementCoords } from '@shared/openlayers/ol-utils';

export const openMapToolContextMenu = (pixel: Pixel, feature: Feature, type: 'distance-measurement' | 'area-measurement' | 'volume-measurement') => {
    const ctxModel = [];
    if (type === 'distance-measurement' || type === 'area-measurement') {
        ctxModel.push(
            {
                label: __('js_map_measuring_tools.modify'),
                checked: !!mapTools.toolInteractions.modifyInteractionUserEnabled,
                action: () => mapTools.toolInteractions.toggleModifyUserEnabled(),
            },
            {
                label: __('js_map_measuring_tools.snap_to_models'),
                checked: !!mapTools.toolInteractions.snapModelsInteractionUserEnabled,
                action: () => mapTools.toolInteractions.toggleSnapModelsUserEnabled(),
            },
            {
                label: __('js_map_measuring_tools.snap_to_n_gons', mapTools.toolInteractions.gonsInterval),
                checked: !!mapTools.toolInteractions.snapGonsInteraction,
                action: () => mapTools.toolInteractions.toggleSnapGonsUserEnabled(),
            },
            {
                label: __('js_map_measuring_tools.segment_labels'),
                checked: !!mapTools.showSegmentLabels,
                action: () => mapTools.toggleShowSegmentLabels(),
            }
        );
    }
    if (typeof mapTools.activeTool?.cancelCurrentDrawing === 'function') {
        mapTools.activeTool.cancelCurrentDrawing();
    }
    if (mapTools.activeTool instanceof AreaTool || type === 'area-measurement') {
        ctxModel.push(
            ...[
                null,
                // {
                //     label: __('js_map.ai_crop'),
                //     action: () => mapTools.areaTool.aiZoom(feature),
                // },
                // {
                //     label: __('js_map.find_similar'),
                //     action: () => mapTools.areaTool.findSimilar(feature),
                // },
                {
                    label: __('js_map.export_drawing_xml_tin'),
                    action: () => XmlExport.exportSurface(),
                },
                {
                    label: __('js_map.export_drawings_xml'),
                    action: () => XmlExport.exportAreas(),
                },
                {
                    label: __('js_map.export_drawings_kml'),
                    action: () => KmlExport.export(mapTools.areaTool.drawLayer.getSource().getFeatures()),
                },
            ]
        );

        if (kuura.hasPrivilege('TRUCKS_PAGE')) {
            ctxModel.push({
                label: __('trucks.create_geofence'),
                action: async () => {
                    const el = Drawer.open(380);
                    el.classList.add('overlay-loading');
                    const materialsStore = new MaterialsStore(new GeofencesStore());
                    await materialsStore.fetch();
                    el.classList.remove('overlay-loading');
                    GeofenceEditor.open(mapWrapper, new GeofencesStore(), materialsStore, null, feature);
                },
            });
        }
    } else if (mapTools.activeTool === mapTools.volumeTool || type === 'volume-measurement') {
        ctxModel.push(
            ...[
                null,
                // {
                //     label: __('js_map.ai_zoom'),
                //     action: () => mapTools.volumeTool.aiZoom(feature),
                // },
                {
                    label: __('js_map.export_drawing_xml_tin'),
                    action: () => XmlExport.exportSurface(),
                },
                {
                    label: __('js_map.export_drawings_xml'),
                    action: () => XmlExport.exportAreas(),
                },
                {
                    label: __('js_map.export_drawings_kml'),
                    action: () => KmlExport.export(mapTools.volumeTool.drawLayer.getSource().getFeatures()),
                },
            ]
        );
    } else if (type === 'distance-measurement') {
        ctxModel.push({
            label: __('js_map.export_drawings_xml'),
            action: () => XmlExport.exportDistances(),
        });
    }

    ctxModel.push(null);
    if (type !== 'volume-measurement') {
        ctxModel.push({
            label: __('js_map_measuring_tools.save_measurement'),
            icon: 'iconf-save',
            action: () => {
                const coords = getSingleMeasurementCoords(feature, type);
                MeasurementEditor.open(null, mapRootStore.treeData, mapTools.simpleMeasurementsStore, coords);
            },
        });
    }
    ctxModel.push({
        label: __('js_map.tools.clear'),
        icon: 'iki iki-trash',
        action: () => mapTools.removeMeasurement(feature),
    });

    renderContextMenuAtPosition(ctxModel, pixel[0], pixel[1], 'measurement-context', () => null);
};
